import { render, staticRenderFns } from "./DialogPromotion.vue?vue&type=template&id=3d3eaf28&scoped=true&"
import script from "./DialogPromotion.vue?vue&type=script&lang=js&"
export * from "./DialogPromotion.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=3d3eaf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3eaf28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d3eaf28')) {
      api.createRecord('3d3eaf28', component.options)
    } else {
      api.reload('3d3eaf28', component.options)
    }
    module.hot.accept("./DialogPromotion.vue?vue&type=template&id=3d3eaf28&scoped=true&", function () {
      api.rerender('3d3eaf28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promotions/DialogPromotion.vue"
export default component.exports